import React from 'react';

import pdfIcon from '../../../../assets/images/pdf.svg';

function PreviewItem({attachment, onRemove, disableAction}) {
  function url() {
    if (
      attachment.type === 'application/pdf' ||
      attachment.attachment_file_content_type === 'application/pdf'
    )
      return pdfIcon;

    if (attachment.id) {
      return attachment.url;
    } else {
      return URL.createObjectURL(attachment);
    }
  }

  function removeButton() {
    if ((disableAction && !!attachment.id) || !onRemove) return;

    return (
      <button
        data-test="remove-file-button"
        data-testid="remove-file-button"
        className="ds-btn -danger --micro _icon _rounded _remove"
        onClick={onRemove.bind(this, attachment)}>
        <i className="materialIcon">close</i>
      </button>
    );
  }

  function linkUrl() {
    if (attachment.id) {
      return attachment.url;
    } else {
      return URL.createObjectURL(attachment);
    }
  }

  return (
    <li className="thumbItem">
      {removeButton()}
      <a href={linkUrl()} target="_blank">
        <img src={url()} alt='item' />
      </a>
    </li>
  );
}

export default PreviewItem;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/PreviewItem.js